import React from 'react';
type SectionHeadingProps = {
  children: React.ReactNode;
  eyebrow?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  children,
  eyebrow,
  align = 'center'
}: SectionHeadingProps) {
  return <header className={align === 'center' ? 'text-center' : 'text-left'} data-id="element-204" data-mp="3f25c14r7ckko">
      {eyebrow ? <p className="mb-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-gold-500" data-id="element-205" data-mp="3k187bxhdrcfg">
          {eyebrow}
        </p> : null}
      <h2 className="font-display text-[26px] font-semibold leading-[1.25] tracking-[-0.015em] text-ink-900 md:text-[30px]" data-id="element-206" data-mp="bmgdylhcadwh">
        {children}
      </h2>
    </header>;
}